Object.defineProperty(exports, '__esModule', { value: true });

const FOCUS_EVENT = 0;
const RECONNECT_EVENT = 1;
const MUTATE_EVENT = 2;
const ERROR_REVALIDATE_EVENT = 3;

exports.ERROR_REVALIDATE_EVENT = ERROR_REVALIDATE_EVENT;
exports.FOCUS_EVENT = FOCUS_EVENT;
exports.MUTATE_EVENT = MUTATE_EVENT;
exports.RECONNECT_EVENT = RECONNECT_EVENT;
